import { useMemo } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { createApiClient, type ApiClient } from './apiClient'
import { API_BASE_URL } from '~/config/api'

export function useApiClient(): ApiClient {
  const { getAccessTokenSilently } = useAuth0()
  return useMemo(
    () =>
      createApiClient({
        baseUrl: API_BASE_URL,
        getToken: () => getAccessTokenSilently(),
      }),
    [getAccessTokenSilently],
  )
}
